export default __webpack_public_path__ + "static/media/auth-image-new.24486a63.jpg";